import { UserRoles, UserStatuses } from '../enums/status';
import { t } from 'i18next';

export const userOptions: { value: string; label: string }[] = [
  {
    value: UserStatuses.ACTIVE,
    label: t('common.userStatuses.active'),
  },
  {
    value: UserStatuses.PENDING,
    label: t('common.userStatuses.pending'),
  },
];

export const userRoles: { value: string, label: string }[] = [
  {
    value: UserRoles.ADMIN,
    label: t('common.terms.admin'),
  },
  {
    value: UserRoles.USER,
    label: t('common.terms.user'),
  },
];
